import { render, staticRenderFns } from "./PackageTeaser.vue?vue&type=template&id=e2adcde2&lang=pug&"
import script from "./PackageTeaser.vue?vue&type=script&lang=js&"
export * from "./PackageTeaser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports